
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Modal,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import upload from '../../../Img/upload.svg'
import { styled } from '@mui/material/styles';




export default function Pan({ activeStep, setActiveStep }) {

  // console.log( activeStep," setActiveStep" )


  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  const [otp, setOtp] = useState(['', '', '', '', '', '']);

  const handleOtpChange = (index, event) => {
    const value = event.target.value;
    const newOtp = [...otp];

    // Ensure only numbers are entered
    const numericValue = value.replace(/\D/g, '');

    // Limit the input to a single digit
    newOtp[index] = numericValue.slice(0, 1);

    setOtp(newOtp);

    // Focus on the next input field if a digit is entered
    if (numericValue.length > 0 && index < 5) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      nextInput && nextInput.focus();
    }
  };



  const [firstField, setFirstField] = useState('');
  const [secondField, setSecondField] = useState('');
  const [thirdField, setThirdField] = useState('');

  const handleInputChange = (field, value) => {
    const trimmedValue = value.slice(0, 4); // Limit to 4 characters
    switch (field) {
      case 'first':
        setFirstField(trimmedValue);
        break;
      case 'second':
        setSecondField(trimmedValue);
        break;
      case 'third':
        setThirdField(trimmedValue);
        break;
      default:
        break;
    }
  };


  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const [frontimage, setfrontimage] = React.useState(null);
  const [backimage, setbackimage] = React.useState(null);

  // Handle the change in file input (on file selection)
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate image URL
      setfrontimage(imageUrl); // Set the image URL to the state
    }
  }

  const handleFileChange1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file); // Generate image URL
      setbackimage(imageUrl); // Set the image URL to the state
    }
  }
  const [panupload, setpanupload] = useState(false);

  const handleshowimg = () => {
    setpanupload(true);
  }

  return (
    <div>
      {!panupload ?
        <div className="aadhar_sec" >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ margin: "auto" }} >
              <h4><span>PAN Card </span> Verification</h4>
              <div className="note"><span>Note:</span> Ensure that the PAN number is entered correctly, including case sensitivity.
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ margin: "auto" }} >
              <label>Enter your PAN Number</label>
              <div className="input_box">
                <TextField
                  fullWidth
                  sx={{
                    borderRadius: "8px",
                    "& .MuiInputBase-formControl": { borderRadius: "8px" },
                    "& .MuiInputBase-input": { padding: "11px  0 11px 30px", border: "0" },
                    "& fieldset": { border: "1px solid #474d57 !important" },
                    "& .MuiInputBase-input::placeholder": { color: "#707a8a", fontSize: "15px" },
                  }}
                />
              </div>
              <Link to={"#"} className='org_btn sm_txt' style={{
                borderRadius: "8px", padding: "12px 60px", margin: "20px 0 0", display: "flex", alignItems: "center", gap: "10px",
                borderRadius: "6px", textAlign: "center", justifyContent: "center"
              }} onClick={handleshowimg} >
                Get OTP <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M-0.00976562 7.72461C-0.00976562 7.34491 0.272388 7.03112 0.638464 6.98146L0.740234 6.97461L15.7402 6.97461C16.1544 6.97461 16.4902 7.3104 16.4902 7.72461C16.4902 8.10431 16.2081 8.4181 15.842 8.46776L15.7402 8.47461L0.740234 8.47461C0.326021 8.47461 -0.00976562 8.13882 -0.00976562 7.72461Z" fill="white" /><path d="M9.16124 2.23247C8.86772 1.94021 8.8667 1.46534 9.15896 1.17181C9.42465 0.904974 9.84126 0.879871 10.1353 1.09709L10.2196 1.16953L16.2696 7.19353C16.5373 7.46002 16.5616 7.87813 16.3426 8.1722L16.2697 8.25643L10.2197 14.2814C9.92616 14.5737 9.45129 14.5727 9.159 14.2792C8.89329 14.0124 8.86994 13.5957 9.08841 13.3025L9.1612 13.2186L14.6772 7.7247L9.16124 2.23247Z" fill="white" /></svg>
              </Link>
            </Grid>
          </Grid>
        </div>

        :
        <div className="aadhar_sec" >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ margin: "auto" }} >
              <h4><span>PAN Card </span> Verification</h4>
              <div className="note"><span>Note:</span> Ensure that the PAN number is entered correctly, including case sensitivity.
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{ margin: "auto" }} >
              <p>Upload your Front & Back PAN Card photo</p>
              <div className="ulpoads" >
                {frontimage && (
                  <div className="upload_box" >
                    <img
                      src={frontimage}
                      alt="Selected"
                      style={{ maxWidth: '100%', height: "auto" }}
                    />
                  </div>
                )}
                {!frontimage && (
                  <div className="upload_box" >
                    <Button component="label" variant="contained" tabIndex={-1} >
                      <img src={upload} alt="img" />
                      <VisuallyHiddenInput
                        type="file"
                        onChange={handleFileChange}
                        accept="image/*"
                      />
                    </Button>
                  </div>
                )}
                {backimage && (
                  <div className="upload_box" >
                    <img
                      src={backimage}
                      alt="Selected"
                      style={{ maxWidth: '100%', height: "auto" }}
                    />
                  </div>
                )}
                {!backimage && (
                  <div className="upload_box" >
                    <Button component="label" variant="contained" tabIndex={-1} >
                      <img src={upload} alt="img" />
                      <VisuallyHiddenInput
                        type="file"
                        onChange={handleFileChange1}
                        accept="image/*"
                      />
                    </Button>
                  </div>
                )}
              </div>
              {frontimage && backimage &&
                <Link to={"#"} className='org_btn sm_txt' style={{
                  padding: "12px 60px", margin: "20px 0 0", borderRadius: "8px", display: "flex", alignItems: "center", gap: "10px",
                  borderRadius: "6px", textAlign: "center", justifyContent: "center"
                }} onClick={() => { setActiveStep(2) }}>Submit
                </Link>
              }
              {!frontimage && !backimage &&
                <Link className='grey_btn' disabled style={{ display: "block", padding: "12px 10px", margin: "20px 0", borderRadius: "8px" }} >Upload </Link>
              }
            </Grid>
          </Grid>
        </div>
      }

    </div>
  );
}
